import { AgentStatusType } from '../enums/invite-status-type.enum';
import { RegisterOriginType } from '../enums/register-origin-type-enum';
import { InitialOriginType } from '../enums/initial-origin-type-enum';
import { RegistrationHistory } from './registration-history';
import { InvestorRepresentative } from './investor-representative';
import { PersonType } from '../enums/person-type.enum';
import { ProductRelationship } from './product-relationship';
import { Distributor } from './distributor';
import { ServiceRelationship } from './service-relationship';
import { ServicesTypes } from '../enums/services.enum';

export class AgentRegister {
  public constructor(init?: Partial<AgentRegister>) {
    Object.assign(this, init);
  }
  id?: string;
  name?: string;
  email?: string;
  document: string;
  inviteID: string;
  personType: PersonType;
  entitiesType: string[];
  registrationHistory: RegistrationHistory[];
  status: keyof typeof AgentStatusType;
  riskLevel?: string;
  pep: boolean;
  cft: boolean;
  cftVerificationDate: string;
  insertedScript?: Number;
  createdByUser?: string;
  createdByUsername?: string;
  registerDate?: Date;
  returnReasons?: String;
  registerOriginType?: keyof typeof RegisterOriginType;
  initialOriginType?: keyof typeof InitialOriginType;
  fullRegister?: boolean;
  investorRepresentative: InvestorRepresentative;
  cellPhone: string;
  HandShake?: Number;
  isExternal: boolean;
  isRepresentativeFilling: boolean;
  madeByRepresentative: boolean;
  key?: string;
  updateProcess: boolean;
  requestedLastUpdateAt: Date;
  productRelationship?: ProductRelationship[];
  distributor?: Distributor;
  services?: ServiceRelationship[];

  public isBancoLiquidanteTitular() {
    return (
      this.services &&
      this.services.some(
        (service) =>
          service.description === ServicesTypes.BANCO_LIQUIDANTE_TITULAR
      )
    );
  }

  public isFundo() {
    return (
      this.services &&
      this.services.some(
        (service) => service.description === ServicesTypes.FUNDOS
      )
    );
  }

  public isEscrowTitular() {
    return (
      this.services &&
      this.services.some(
        (service) => service.description === ServicesTypes.CONTA_ESCROW_TITULAR
      )
    );
  }

  public isEscrowPartesRelacionadas() {
    return (
      this.services &&
      this.services.some(
        (service) =>
          service.description === ServicesTypes.CONTA_ESCROW_PARTES_RELACIONADAS
      )
    );
  }

  public isBancoLiquidantePartesRelacionadas() {
    return (
      this.services &&
      this.services.some(
        (service) =>
          service.description ===
          ServicesTypes.BANCO_LIQUIDANTE_PARTES_RELACIONADAS
      )
    );
  }

  public ehEmissor() {
    return this.personType === PersonType.Emissor;
  }
}
